import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { AddScanningElement, GetScanningElementByCatagory } from '../../../../store/FLEET/FleetScan/fleetScanSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { GetFleetCategory, GetLookupPRIORITY } from '../../../../store/Lookup/lookupSlice';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { useNavigate, useParams } from 'react-router-dom';
import ScanElementList from './ScanElementList';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import EditElement from './EditElement';
import { AddFleetElementSchema } from '../../../ValidationForm/validationSchema';
import Loading from '../../../../components/Shared/Loader/Loading';
import useLookupFleetInspectionType from '@hooks/Lookups/use-Lookup-FleetInspectionType';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const AddElement = () => {
  const { HasPermission } = usePermissions();
  const [ID, setID] = useState<string>(''); // لتعريفة من مكون القائمة ومن ثم استعماله في مكون التعديل

  const Navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const { catagory, lookupType } = useParams();

  const { FleetInspectionTypeOptions } = useLookupFleetInspectionType();

  useEffect(() => {
    dispatch(GetFleetCategory());
    dispatch(GetLookupPRIORITY());
    dispatch(GetScanningElementByCatagory({ catagory: catagory || '', lookupType: lookupType || '' }));
  }, [catagory, dispatch, lookupType]);

  const { FleetCategory, PRIORITY } = useAppSelector(state => state.Lookup);
  const { loading } = useAppSelector(state => state.FleetScan);

  const formik = useFormik({
    initialValues: {
      id: '',
      name: '',
      name2: '',
      description: '',
      description2: '',
      sort: '',
      catagory: catagory,
      lookupType: lookupType || null,
      priority: 'Medium'
    },
    enableReinitialize: true,
    validationSchema: AddFleetElementSchema(t),
    onSubmit: values => {
      dispatch(
        AddScanningElement({
          name: values.name,
          name2: values.name2,
          description: values.description,
          description2: values.description2,
          lookupType: values.lookupType,
          catagory: values.catagory,
          sort: Number(values.sort),
          priority: values.priority
        })
      )
        .unwrap()
        .then(res => {
          // debugger
          if (res?.succeeded === true) {
            // document.getElementById('closeModalForm')?.click();
            formik.resetForm();
            CustomAlert({ action: 'Add' });
            dispatch(GetScanningElementByCatagory({ catagory: catagory || '', lookupType: lookupType || '' }));
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
           link: ':moduleHome'
          },
          {
            name: 'InspectionItems',
            link: '/FLEETSettings/FleetElementScan'
          },
          {
            name: 'AddInspectionItems',
            link: null
          }
        ]}
        PageName='AddInspectionItems'
        subtitle={
          FleetInspectionTypeOptions?.find((f: any) => f.value === lookupType)?.label ||
          `${t('Handover')} - ${t('Takeover')}`
        }
      />

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <div className='row'>
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('LocalName')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='name2'
                      onChange={formik.handleChange}
                      value={formik.values.name2}
                      isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name}</Form.Control.Feedback>
                  </div>
                </div>
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('GlobalName')}</label>
                    <Form.Control
                      className='form-control'
                      type='text'
                      autoComplete='off'
                      name='name'
                      onChange={formik.handleChange}
                      value={formik.values.name}
                      isInvalid={!!(formik.touched.name && formik.errors.name)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.name2}</Form.Control.Feedback>
                  </div>
                </div>
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Catagory')}</label>
                    <Form.Select
                      disabled
                      className='form-select pt-'
                      name='catagory'
                      onChange={formik.handleChange}
                      value={formik.values.catagory}
                      isInvalid={!!(formik.touched.catagory && formik.errors.catagory)}
                    >
                      <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {FleetCategory &&
                        FleetCategory?.map((item: any, idx) =>
                          item?.list?.map((list: any) => (
                            <option key={++idx} value={list.lookupCode}>
                              {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                            </option>
                          ))
                        )}
                    </Form.Select>
                    <Form.Control.Feedback type='invalid'>{formik.errors.catagory}</Form.Control.Feedback>
                  </div>
                </div>
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Order')}</label>
                    <Form.Control
                      className='form-control'
                      type='number'
                      name='sort'
                      onChange={formik.handleChange}
                      value={formik.values.sort}
                      isInvalid={!!(formik.touched.sort && formik.errors.sort)}
                    />

                    <Form.Control.Feedback type='invalid'>{formik.errors.sort}</Form.Control.Feedback>
                  </div>
                </div>
                <div className='col-xl-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Priority')} </label>
                    <Form.Select
                      className='form-select'
                      name='priority'
                      onChange={formik.handleChange}
                      value={formik.values.priority}
                      isInvalid={!!(formik.touched.priority && formik.errors.priority)}
                    >
                      <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PRIORITY &&
                        PRIORITY?.map((item: any, idx) =>
                          item?.list?.map((list: any) => (
                            <option key={++idx} value={list.lookupCode}>
                              {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                            </option>
                          ))
                        )}
                    </Form.Select>
                    <Form.Control.Feedback type='invalid'>{formik.errors.priority}</Form.Control.Feedback>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('DescriptionAR')}</label>
                    <Form.Control
                      className='form-control'
                      as='textarea'
                      rows={3}
                      name='description2'
                      onChange={formik.handleChange}
                      value={formik.values.description2}
                      isInvalid={!!(formik.touched.description2 && formik.errors.description2)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.description2}</Form.Control.Feedback>
                  </div>
                </div>

                <div className='col-xl-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('DescriptionEN')}</label>
                    <Form.Control
                      style={{ direction: 'ltr' }}
                      className='form-control'
                      as='textarea'
                      rows={3}
                      name='description'
                      onChange={formik.handleChange}
                      value={formik.values.description}
                      isInvalid={!!(formik.touched.description && formik.errors.description)}
                    />
                    <Form.Control.Feedback type='invalid'>{formik.errors.description}</Form.Control.Feedback>
                  </div>
                </div>
              </div>

              <div className='text-center'>
                <button
                  hidden={!HasPermission('FleetAddInspectionItems')}
                  disabled={formik.isSubmitting}
                  type='submit'
                  className='btn me-1 btn-theme mb-1'
                  id='SaveSubmit'
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                  )}
                  {t('Add')}
                </button>
                <button
                  type='button'
                  className=' btn me-1 btn-default mb-1'
                  onClick={() => Navigate('/FLEETSettings/FleetElementScan', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </Form>
            <hr />
            <div className='  pt-1'>
              <ScanElementList setID={setID} />
            </div>
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('EditInspectionItems')} id='EditElementModal'>
        {ID && <EditElement ID={ID} />}
      </ModalComponent>
    </div>
  );
};

export default AddElement;
